/*
  Aura: favoritos (wishlist) da loja, guardados no próprio navegador do cliente.
  Contrato (vale para qualquer seção ou snippet):
  - [data-aura-wishlist="<handle>"]  botão que liga e desliga o produto nos favoritos
    (recebe aria-pressed, a classe is-active e a classe is-pulse por um instante ao clicar).
  - [data-aura-wishlist-count]       mostra quantos produtos estão salvos (fica com hidden quando é 0).
  - [data-aura-wishlist-remove="<handle>"] botão que só tira o produto.
  - [data-aura-wishlist-link]        coração do cabeçalho (pulsa quando um produto entra).
  - evento "aura:wishlist:change" no document, com detail { handles, handle, active, count }.
  - window.AuraWishlist: get(), has(h), add(h), remove(h), toggle(h), count().
  Lista no localStorage, chave "aura_wishlist_v1": handles, o mais novo primeiro.
*/
(function () {
  if (window.AuraWishlist) return;

  var KEY = 'aura_wishlist_v1';
  var MAX = 200;
  var memoria = [];

  function limpar(lista) {
    var vistos = {};
    var out = [];
    (Array.isArray(lista) ? lista : []).forEach(function (h) {
      if (typeof h !== 'string') return;
      h = h.trim();
      if (!h || vistos[h]) return;
      vistos[h] = true;
      out.push(h);
    });
    return out.slice(0, MAX);
  }

  function ler() {
    try {
      var bruto = window.localStorage.getItem(KEY);
      memoria = limpar(bruto ? JSON.parse(bruto) : []);
    } catch (e) {}
    return memoria.slice();
  }

  function salvar(lista) {
    memoria = limpar(lista);
    try {
      window.localStorage.setItem(KEY, JSON.stringify(memoria));
    } catch (e) {}
  }

  function avisar(handle, active) {
    var lista = memoria.slice();
    sincronizar();
    document.dispatchEvent(
      new CustomEvent('aura:wishlist:change', {
        bubbles: true,
        detail: { handles: lista, handle: handle || null, active: !!active, count: lista.length },
      })
    );
  }

  function has(h) {
    return ler().indexOf(h) !== -1;
  }

  function add(h) {
    if (!h) return;
    var lista = ler().filter(function (x) { return x !== h; });
    lista.unshift(h);
    salvar(lista);
    avisar(h, true);
  }

  function remove(h) {
    if (!h) return;
    var lista = ler();
    if (lista.indexOf(h) === -1) return;
    salvar(lista.filter(function (x) { return x !== h; }));
    avisar(h, false);
  }

  function toggle(h) {
    if (has(h)) {
      remove(h);
      return false;
    }
    add(h);
    return true;
  }

  /* Deixa todos os botões e contadores da página iguais à lista salva */
  function sincronizar() {
    var lista = memoria;
    var mapa = {};
    lista.forEach(function (h) { mapa[h] = true; });

    document.querySelectorAll('[data-aura-wishlist]').forEach(function (el) {
      var h = el.getAttribute('data-aura-wishlist');
      var ativo = !!mapa[h];
      if (el.tagName !== 'BUTTON' && !el.hasAttribute('role')) {
        el.setAttribute('role', 'button');
        if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0');
      }
      if (el.getAttribute('aria-pressed') !== String(ativo)) el.setAttribute('aria-pressed', String(ativo));
      el.classList.toggle('is-active', ativo);
    });

    var n = lista.length;
    document.querySelectorAll('[data-aura-wishlist-count]').forEach(function (el) {
      var txt = n > 99 ? '99+' : String(n);
      if (el.textContent !== txt) el.textContent = txt;
      if (n === 0) el.setAttribute('hidden', '');
      else el.removeAttribute('hidden');
    });
  }

  function pulsar(el) {
    el.classList.remove('is-pulse');
    void el.offsetWidth;
    el.classList.add('is-pulse');
    window.setTimeout(function () { el.classList.remove('is-pulse'); }, 450);
  }

  /* Se algum efeito do card (ex.: animação ao passar o mouse) deixar o link do produto por cima do coração,
     o clique cai no link; aqui confere se havia um coração do mesmo card embaixo do ponteiro. */
  function coracaoSobPonteiro(ev, alvo) {
    if (!document.elementsFromPoint || (!ev.clientX && !ev.clientY)) return null;
    var card = alvo.closest('.card-wrapper, .card, .grid__item');
    if (!card) return null;
    var pilha = document.elementsFromPoint(ev.clientX, ev.clientY);
    for (var i = 0; i < pilha.length; i++) {
      var el = pilha[i].closest ? pilha[i].closest('[data-aura-wishlist]') : null;
      if (el && card.contains(el)) return el;
    }
    return null;
  }

  /* Clique: captura no window para o clique no coração nunca abrir o produto do card */
  window.addEventListener(
    'click',
    function (ev) {
      var alvo = ev.target && ev.target.closest ? ev.target : null;
      if (!alvo) return;
      var tirar = alvo.closest('[data-aura-wishlist-remove]');
      if (tirar) {
        ev.preventDefault();
        ev.stopPropagation();
        remove(tirar.getAttribute('data-aura-wishlist-remove'));
        return;
      }
      var botao = alvo.closest('[data-aura-wishlist]') || coracaoSobPonteiro(ev, alvo);
      if (!botao) return;
      ev.preventDefault();
      ev.stopPropagation();
      if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();
      var ligou = toggle(botao.getAttribute('data-aura-wishlist'));
      if (ligou) {
        pulsar(botao);
        /* o coração do cabeçalho também pulsa: mostra para onde o produto foi */
        document.querySelectorAll('[data-aura-wishlist-link]').forEach(pulsar);
      }
    },
    true
  );

  /* Teclado para coração que não é <button> */
  document.addEventListener('keydown', function (ev) {
    if (ev.key !== 'Enter' && ev.key !== ' ') return;
    var el = ev.target;
    if (!el || el.tagName === 'BUTTON' || !el.matches || !el.matches('[data-aura-wishlist]')) return;
    ev.preventDefault();
    el.click();
  });

  /* Outra aba mudou a lista */
  window.addEventListener('storage', function (ev) {
    if (ev.key !== KEY) return;
    ler();
    avisar(null, false);
  });

  /* Cards que entram depois (filtros, carrosséis, recarga de seção no editor) */
  var agendado = false;
  function agendar() {
    if (agendado) return;
    agendado = true;
    window.requestAnimationFrame(function () {
      agendado = false;
      sincronizar();
    });
  }
  function observar() {
    if (!document.body || !window.MutationObserver) return;
    new MutationObserver(function (muds) {
      for (var i = 0; i < muds.length; i++) {
        var add = muds[i].addedNodes;
        for (var j = 0; j < add.length; j++) {
          var n = add[j];
          if (n.nodeType === 1 && (n.matches('[data-aura-wishlist],[data-aura-wishlist-count]') || n.querySelector('[data-aura-wishlist],[data-aura-wishlist-count]'))) {
            agendar();
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
  document.addEventListener('shopify:section:load', agendar);

  window.AuraWishlist = {
    key: KEY,
    get: ler,
    has: has,
    add: add,
    remove: remove,
    toggle: toggle,
    count: function () { return ler().length; },
    sync: function () { ler(); sincronizar(); },
  };

  ler();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { sincronizar(); observar(); });
  } else {
    sincronizar();
    observar();
  }

  /* ---------- Gaveta de favoritos (Aura 03/10/2026, pedido do Felipe) ----------
     O coração do cabeçalho ([data-aura-wishlist-link]) abre a gaveta <aura-wishlist-gaveta> (snippet aura-wishlist-gaveta),
     igual ao carrinho, no lugar de carregar a página de favoritos (que continua existindo; Ctrl+clique ainda abre a página).
     Cada linha vem de /products/<handle>?section_id=aura-wishlist-linha e fica guardada na sessão do navegador
     por 15 minutos: nas próximas páginas a gaveta abre na hora, sem esperar a internet. */
  var LINHA_SECAO = 'aura-wishlist-linha';
  var CACHE_KEY = 'aura_wlg_linhas_v1';
  var CACHE_MS = 15 * 60 * 1000;
  var linhasMem = {};
  var buscando = {};

  function lerCache() {
    try { return JSON.parse(window.sessionStorage.getItem(CACHE_KEY) || '{}') || {}; } catch (e) { return {}; }
  }
  function gravarCache(c) {
    try { window.sessionStorage.setItem(CACHE_KEY, JSON.stringify(c)); } catch (e) {}
  }
  function linhaGuardada(h) {
    if (linhasMem[h]) return linhasMem[h];
    var c = lerCache()[h];
    if (c && Date.now() - c.t < CACHE_MS) {
      linhasMem[h] = c.html;
      return c.html;
    }
    return null;
  }
  function guardarLinha(h, html) {
    linhasMem[h] = html;
    var c = lerCache();
    var agora = Date.now();
    Object.keys(c).forEach(function (k) { if (agora - c[k].t >= CACHE_MS) delete c[k]; });
    c[h] = { html: html, t: agora };
    gravarCache(c);
  }
  function raizLoja() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }
  function buscarLinha(h) {
    var g = linhaGuardada(h);
    if (g) return Promise.resolve({ html: g });
    if (buscando[h]) return buscando[h];
    buscando[h] = fetch(raizLoja() + 'products/' + encodeURIComponent(h) + '?section_id=' + LINHA_SECAO, { credentials: 'same-origin' })
      .then(function (r) {
        if (r.status === 404) return { sumiu: true };
        if (!r.ok) return null;
        return r.text().then(function (txt) {
          var doc = new DOMParser().parseFromString(txt, 'text/html');
          var el = doc.querySelector('[data-wl-linha]');
          if (!el) return null;
          guardarLinha(h, el.innerHTML);
          /* já baixa a foto, para a linha aparecer completa quando a gaveta abrir */
          var foto = el.querySelector('img[src]');
          if (foto) new Image().src = foto.getAttribute('src');
          return { html: el.innerHTML };
        });
      })
      .catch(function () { return null; })
      .then(function (res) {
        delete buscando[h];
        return res;
      });
    return buscando[h];
  }
  function aspas(t) {
    return String(t).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
  }
  function seletorHandle(h) {
    var v = window.CSS && CSS.escape ? CSS.escape(h) : String(h).replace(/["\\]/g, '\\$&');
    return '[data-wl-handle="' + v + '"]';
  }
  function preCarregar() {
    ler().slice(0, 12).forEach(function (h) { if (!linhaGuardada(h)) buscarLinha(h); });
  }

  if (window.customElements && !window.customElements.get('aura-wishlist-gaveta')) {
    class AuraWishlistGaveta extends HTMLElement {
      connectedCallback() {
        /* a gaveta mora direto no body (fora do cabeçalho), para ficar por cima de tudo; no editor do tema,
           quando o cabeçalho recarrega, a gaveta nova substitui a antiga */
        if (this.parentNode !== document.body) {
          var self = this;
          document.querySelectorAll('body > aura-wishlist-gaveta').forEach(function (velha) { if (velha !== self) velha.remove(); });
          document.body.appendChild(this);
          return;
        }
        if (this._pronta) return;
        this._pronta = true;
        this.lista = this.querySelector('[data-wlg-lista]');
        this.vazio = this.querySelector('[data-wlg-vazio]');
        this.total = this.querySelector('[data-wlg-total]');
        this.painel = this.querySelector('.aura-wlg__painel');
        this.aoMudar = this.mudou.bind(this);
        this.aoTecla = this.tecla.bind(this);
        this.aoClicar = this.clicou.bind(this);
        document.addEventListener('aura:wishlist:change', this.aoMudar);
        this.addEventListener('click', this.aoClicar);
      }

      disconnectedCallback() {
        if (!this._pronta) return;
        this._pronta = false;
        document.removeEventListener('aura:wishlist:change', this.aoMudar);
        document.removeEventListener('keydown', this.aoTecla);
        this.removeEventListener('click', this.aoClicar);
        document.documentElement.classList.remove('aura-wlg-travado');
      }

      clicou(ev) {
        if (ev.target.closest && ev.target.closest('[data-wlg-fechar]')) this.fechar();
      }

      abrir() {
        if (!this._pronta) return;
        this.focoAntes = document.activeElement;
        clearTimeout(this._t);
        this.hidden = false;
        document.documentElement.classList.add('aura-wlg-travado');
        void this.offsetWidth;
        this.classList.add('is-aberto');
        document.addEventListener('keydown', this.aoTecla);
        this.montar();
        var p = this.painel;
        setTimeout(function () { try { p.focus({ preventScroll: true }); } catch (e) {} }, 60);
      }

      fechar() {
        var self = this;
        this.classList.remove('is-aberto');
        document.documentElement.classList.remove('aura-wlg-travado');
        document.removeEventListener('keydown', this.aoTecla);
        clearTimeout(this._t);
        this._t = setTimeout(function () { if (!self.classList.contains('is-aberto')) self.hidden = true; }, 300);
        if (this.focoAntes && this.focoAntes.focus) {
          try { this.focoAntes.focus({ preventScroll: true }); } catch (e) {}
        }
      }

      tecla(ev) {
        if (ev.key === 'Escape') {
          this.fechar();
          return;
        }
        if (ev.key !== 'Tab') return;
        var focaveis = Array.prototype.filter.call(
          this.painel.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'),
          function (el) { return el.offsetParent !== null; }
        );
        if (!focaveis.length) return;
        var primeiro = focaveis[0], ultimo = focaveis[focaveis.length - 1];
        if (ev.shiftKey && (document.activeElement === primeiro || document.activeElement === this.painel)) {
          ev.preventDefault();
          ultimo.focus();
        } else if (!ev.shiftKey && document.activeElement === ultimo) {
          ev.preventDefault();
          primeiro.focus();
        }
      }

      contar(n) {
        if (!this.total) return;
        this.total.textContent = n ? '(' + n + ')' : '';
        this.total.hidden = !n;
      }

      linhaHtml(h, html) {
        return '<li class="aura-wlg-item" data-wl-handle="' + aspas(h) + '">' + html + '</li>';
      }

      montar() {
        var self = this;
        var lista = ler();
        var vez = (this.vez = (this.vez || 0) + 1);
        this.contar(lista.length);
        if (!lista.length) {
          this.lista.innerHTML = '';
          this.vazio.hidden = false;
          return;
        }
        this.vazio.hidden = true;
        /* as linhas já guardadas aparecem na hora; as outras ficam em cinza até chegarem */
        this.lista.innerHTML = lista
          .map(function (h) {
            var g = linhaGuardada(h);
            if (g) return self.linhaHtml(h, g);
            return '<li class="aura-wlg-item aura-wlg-item--esqueleto" data-wl-handle="' + aspas(h) + '" aria-hidden="true"><span class="aura-wlg-item__foto"></span><span class="aura-wlg-item__info"><i></i><i></i></span><span></span></li>';
          })
          .join('');
        var faltam = lista.filter(function (h) { return !linhaGuardada(h); });
        if (!faltam.length) return;
        var proximo = 0;
        var sumidos = [];
        function trabalhador() {
          if (proximo >= faltam.length) return Promise.resolve();
          var h = faltam[proximo++];
          return buscarLinha(h).then(function (r) {
            if (vez !== self.vez) return;
            var li = self.lista.querySelector(seletorHandle(h));
            if (r && r.sumiu) {
              sumidos.push(h);
              if (li) li.remove();
            } else if (li) {
              if (r && r.html) li.outerHTML = self.linhaHtml(h, r.html);
              else li.remove();
            }
            return trabalhador();
          });
        }
        var fila = [];
        for (var k = 0; k < Math.min(4, faltam.length); k++) fila.push(trabalhador());
        Promise.all(fila).then(function () {
          if (vez !== self.vez) return;
          if (sumidos.length) {
            /* produto que não existe mais na loja sai da lista */
            salvar(ler().filter(function (h) { return sumidos.indexOf(h) === -1; }));
            avisar(null, false);
          }
        });
      }

      mudou(ev) {
        var d = ev.detail || {};
        if (d.active && d.handle && !linhaGuardada(d.handle)) {
          var novo = d.handle;
          setTimeout(function () { buscarLinha(novo); }, 600);
        }
        if (!this.classList.contains('is-aberto')) return;
        if (d.handle && d.active === false) {
          var self = this;
          var li = this.lista.querySelector(seletorHandle(d.handle));
          this.contar(d.count);
          if (li) {
            li.classList.add('is-saindo');
            setTimeout(function () {
              li.remove();
              if (!ler().length) self.vazio.hidden = false;
            }, 250);
          } else if (!d.count) {
            this.vazio.hidden = false;
          }
          return;
        }
        this.montar();
      }
    }
    window.customElements.define('aura-wishlist-gaveta', AuraWishlistGaveta);
  }

  /* coração do cabeçalho: abre a gaveta (sem gaveta na página, segue para /pages/wishlist) */
  document.addEventListener('click', function (ev) {
    var link = ev.target && ev.target.closest ? ev.target.closest('[data-aura-wishlist-link]') : null;
    if (!link || ev.defaultPrevented) return;
    if (ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey || ev.button > 0) return;
    var gaveta = document.querySelector('aura-wishlist-gaveta');
    if (!gaveta || typeof gaveta.abrir !== 'function' || !gaveta._pronta) return;
    ev.preventDefault();
    gaveta.abrir();
  });
  /* intenção de abrir (mouse em cima, dedo encostando, foco): já busca as linhas que faltam */
  ['pointerover', 'touchstart', 'focusin'].forEach(function (tipo) {
    document.addEventListener(tipo, function (ev) {
      if (ev.target && ev.target.closest && ev.target.closest('[data-aura-wishlist-link]')) preCarregar();
    }, { passive: true });
  });

  /* ---------- Página de favoritos (seção aura-wishlist) ---------- */
  if (!window.customElements || window.customElements.get('aura-wishlist-page')) return;

  class AuraWishlistPage extends HTMLElement {
    connectedCallback() {
      this.grade = this.querySelector('[data-wl-grade]');
      this.vazio = this.querySelector('[data-wl-vazio]');
      this.contador = this.querySelector('[data-wl-total]');
      this.cache = {};
      this.aoMudar = this.mudou.bind(this);
      document.addEventListener('aura:wishlist:change', this.aoMudar);
      this.montar();
    }

    disconnectedCallback() {
      document.removeEventListener('aura:wishlist:change', this.aoMudar);
    }

    raiz() {
      var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return r.charAt(r.length - 1) === '/' ? r : r + '/';
    }

    total(n) {
      if (!this.contador) return;
      var um = this.contador.getAttribute('data-um') || '1 item';
      var varios = this.contador.getAttribute('data-varios') || '[count] items';
      this.contador.textContent = n === 1 ? um : varios.replace('[count]', n);
      this.contador.hidden = n === 0;
    }

    estado(vazio) {
      this.classList.toggle('is-vazio', vazio);
      if (this.vazio) this.vazio.hidden = !vazio;
      if (this.grade) this.grade.hidden = vazio;
    }

    buscar(handle) {
      var self = this;
      if (this.cache[handle]) return Promise.resolve(this.cache[handle]);
      return fetch(this.raiz() + 'products/' + encodeURIComponent(handle) + '?section_id=aura-wishlist', { credentials: 'same-origin' })
        .then(function (r) {
          if (r.status === 404) return { sumiu: true };
          if (!r.ok) return null;
          return r.text().then(function (txt) {
            var doc = new DOMParser().parseFromString(txt, 'text/html');
            var item = doc.querySelector('[data-wl-item]');
            if (!item) return null;
            var res = { html: item.innerHTML };
            self.cache[handle] = res;
            return res;
          });
        })
        .catch(function () { return null; });
    }

    montar() {
      var self = this;
      var lista = ler();
      var vez = (this.vez = (this.vez || 0) + 1);
      this.total(lista.length);
      if (!lista.length) {
        if (this.grade) this.grade.innerHTML = '';
        this.estado(true);
        this.classList.remove('is-carregando');
        return;
      }
      this.estado(false);
      this.classList.add('is-carregando');
      this.grade.innerHTML = lista
        .map(function () { return '<li class="grid__item aura-wl-pagina__item aura-wl-pagina__esqueleto" aria-hidden="true"><span></span><i></i><i></i></li>'; })
        .join('');

      var resultados = new Array(lista.length);
      var proximo = 0;
      function trabalhador() {
        if (proximo >= lista.length) return Promise.resolve();
        var i = proximo++;
        return self.buscar(lista[i]).then(function (r) {
          resultados[i] = r;
          return trabalhador();
        });
      }
      var fila = [];
      for (var k = 0; k < Math.min(6, lista.length); k++) fila.push(trabalhador());
      Promise.all(fila).then(function () {
        if (vez !== self.vez) return;
        var sumidos = [];
        var html = '';
        lista.forEach(function (h, i) {
          var r = resultados[i];
          if (!r) return;
          if (r.sumiu) {
            sumidos.push(h);
            return;
          }
          html += '<li class="grid__item aura-wl-pagina__item" data-wl-handle="' + h.replace(/"/g, '&quot;') + '">' + r.html + '</li>';
        });
        self.classList.remove('is-carregando');
        self.grade.innerHTML = html;
        sincronizar();
        if (sumidos.length) {
          /* produto que não existe mais na loja sai da lista */
          salvar(ler().filter(function (h) { return sumidos.indexOf(h) === -1; }));
          avisar(null, false);
          return;
        }
        var visiveis = self.grade.querySelectorAll('[data-wl-handle]').length;
        self.total(visiveis);
        if (!visiveis) self.estado(true);
      });
    }

    mudou(ev) {
      var d = ev.detail || {};
      if (d.handle && d.active === false && this.grade) {
        var self = this;
        var li = this.grade.querySelector('[data-wl-handle="' + (window.CSS && CSS.escape ? CSS.escape(d.handle) : d.handle) + '"]');
        this.total(d.count);
        if (li) {
          li.classList.add('is-saindo');
          window.setTimeout(function () {
            li.remove();
            if (!self.grade.querySelector('[data-wl-handle]')) self.estado(true);
          }, 260);
          return;
        }
        if (!d.count) {
          this.estado(true);
          return;
        }
      }
      this.montar();
    }
  }

  window.customElements.define('aura-wishlist-page', AuraWishlistPage);
})();
